import { store } from "../../../store";

export const getContactSettings = () => {
  const state = store.getState();
  const dashboardData = state.dashboard.status;

  return {
    fullName: dashboardData?.contact_name || "",
    phone: dashboardData?.phone || "",
    category: dashboardData?.categories?.[0]?.Name || "",
    description: dashboardData?.description || "",
    short_description: dashboardData?.short_description || "",
  };
};
